import React, { useEffect } from 'react';
import useInputHelper from './input/inputHelper';
import { FormFieldsData } from './FormContext';

interface ClearAfterUnmountWrapperCustomizedProps<P extends object> {
  children: React.ReactElement<P>;
  getSources: (props: P) => string[];
  isVisible?: ((data: FormFieldsData) => boolean) | boolean;
}

/**
 * Wrapper that will set value to null after unmount.
 * @constructor
 */
const ClearAfterUnmountWrapperCustomized = <P extends object>({
  children,
  getSources,
}: ClearAfterUnmountWrapperCustomizedProps<P>) => {
  const { getRawOnChangeCallback } = useInputHelper({ ...children.props, source: '' });
  const rawOnChangeCallback = getRawOnChangeCallback();

  /*
   * When is not mounted - value should be null
   */
  useEffect(() => {
    return () => {
      if (rawOnChangeCallback) {
        const data = getSources(children.props).reduce((acc, source) => ({ ...acc, [source]: null }), {});
        rawOnChangeCallback(data);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return children;
};

export default ClearAfterUnmountWrapperCustomized;
